import {cloneElement, Fragment, useCallback} from 'react';

import {useLightBox} from 'topmeteo/general/components/LightBox/Manager';

import LocationManagerLightBox from './LocationManagerLightBox';

const LocationManager = ({children}) => {
    const {show, onClick, onClose} = useLightBox();

    /* We want the event to bubble up so the dropdown is closed. */
    const handleClick = useCallback(() => onClick(null), [onClick]);

    return (
        <Fragment>
            {cloneElement(children, {onClick: handleClick})}
            {show && <LocationManagerLightBox onClose={onClose} />}
        </Fragment>
    );
};

export default LocationManager;
